import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class DateHelper {
  public getDateTicks(ticks: string): number {
    return Number(ticks);
  }

  public getDateMillis(ticks: string): number {
    //TO-DO: there should be more effective solution for the static calculations.
    return (this.getDateTicks(ticks) - 621355968000000000) / 10000;
  }

  public getDate(ticks: string): Date {
    return ticks ? new Date(this.getDateMillis(ticks)) : null;
  }

  public convertDateToTicks(date: Date): number {
    return date.getTime() * 10000 + 621355968000000000;
  }

  public parseTimeToMs(timeStr): number {
    const parts = timeStr.split(':');
    const hours = parseInt(parts[0], 10) || 0;
    const minutes = parseInt(parts[1], 10) || 0;
    const seconds = parseInt(parts[2], 10) || 0;

    return hours * 3600000 + minutes * 60000 + seconds * 1000;
  }
}
